export default __webpack_public_path__ + "static/media/drinks.571dfaf3.svg";